module.exports = __webpack_public_path__ + "static/media/metacognition.aed893d9.png";